<script setup>
import moment from "moment";
import { ref, onMounted, computed, watch } from "vue";
import useChatWidget from "../stores/chatWidget";
import { Button, Icon } from "../../components";

const $chatWidget = useChatWidget();
const $globalSetting = computed(() => $chatWidget.getGlobalSettings());
const $config = $chatWidget.getConfig;
const $setting = $chatWidget.getSettings;
const $payload = $chatWidget.getPayload();
const $availableSlots = computed(() => $chatWidget.getAvailableSlots());
const selectedTime = ref(null);

onMounted(async () => {
  if ($availableSlots.value.length === 0) {
    await $chatWidget.fetchAvailableSlots();
  }
});

watch($availableSlots, (newSlots) => {}, { immediate: true });

watch(
  () => $payload.value?.date,
  async (newDate) => {
    if (newDate) {
      selectedTime.value = null;
      await $chatWidget.fetchAvailableSlots();
    }
  },
  { deep: true }
);

const generateTimeSlots = computed(() => {
  const now = moment();
  const slots = [];

  for (let i = 0; i < 6; i++) {
    const nextSlot = now.clone().add(i * 30, "minutes");
    // Only add slots that are in the future
    if (nextSlot.isAfter(now)) {
      slots.push(nextSlot.format("h:mm A"));
    }
  }

  return slots;
});

const timePeriod = (slot) => {
  const hour = moment(slot.start, "h:mm A").hour();

  if (hour >= 6 && hour < 12) {
    return "Morning";
  } else if (hour >= 12 && hour < 18) {
    return "Afternoon";
  } else {
    return "Evening";
  }
};

const timeIcon = ref({
  Morning: "sunSetting02",
  Afternoon: "sun",
  Evening: "moonStar",
});

const handleTimeSelection = (time) => {
  selectedTime.value = time;

  const tempPayload = $payload;
  tempPayload.time = time;
  tempPayload.step = $payload.step + 1;
  $chatWidget.updatePayload(tempPayload);
};
</script>

<template>
  <div id="prebook-chat-component-time" class="px-4 py-[15px]">
    <div class="inline-flex w-[50px]">
      <img
        :src="$globalSetting?.settings?.business?.full_logo_url"
        :alt="$globalSetting?.settings?.business?.name"
        class="w-full object-contain"
      />
    </div>
    <h2 class="text-[20px]">
      {{ $setting.time.question }}
    </h2>
    <div class="flex flex-wrap gap-2 py-[10px]">
      <Button
        v-for="slot in $availableSlots.filter(
          (slot) =>
            typeof slot.available !== 'undefined' && slot.available === true
        )"
        :key="slot.id"
        @click="handleTimeSelection(slot)"
        class="flex items-center gap-2 rounded-[58px] p-[10px_24px_10px_15px] cursor-pointer border border-[#D0D5DD] text-[#101828]"
        :class="[
          selectedTime == slot
            ? 'border-transparent bg-gray-800 text-white'
            : 'border-[#D0D5DD]',
        ]"
        size="sm"
        type="secondary_gray"
      >
        <Icon :name="timeIcon[timePeriod(slot)]" size="24px" />
        <div class="text-[16px] font-medium">{{ slot.start }}</div>
      </Button>
    </div>
  </div>
  <Transition
    enter-active-class="transition duration-300 ease-out"
    enter-from-class="transform -translate-y-4 opacity-0"
    enter-to-class="transform translate-y-0 opacity-100"
    leave-active-class="transition duration-200 ease-in"
    leave-from-class="transform translate-y-0 opacity-100"
    leave-to-class="transform -translate-y-4 opacity-0"
  >
    <div v-if="$payload?.time" class="p-5 text-right">
      <p class="inline-block bg-gray-200 rounded-[8px] p-4 font-medium m-0">
        <span class="block text-[16px]">{{ $payload?.time.start }}</span>
      </p>
    </div>
  </Transition>
</template>
